module.exports = __webpack_public_path__ + "img/2018_innovation.55b64bc5.jpg";